import Page from "../../../components/Page";
import Header from "../../../components/Header";
import HeroIcon from "../../../assets/img/hero.svg";
import "./styles.css";

const WaitingApplication = () => {
  return (
    <Page
      containerClassName="colorful"
      bodyClassName="waiting-application"
      header={<Header />}
    >
      <div className="col align-items-center gap-24">
        <p className="fw-700 fs-40 c-n800 text-align-center line-height-50 mobile-fs-30 mobile-line-height-36">
          Espera
        </p>
        <p className="fw-700 fs-26 c-n700 text-align-center line-height-34 mobile-fw-500 mobile-fs-18 mobile-line-height-26">
          Estamos validando tus datos
        </p>
        <p className="fw-400 fs-18 c-n700 text-align-center line-height-24">
          Puede tardar algunos minutos, no cierres el navegador
        </p>
        <div className="page-loader" />
        <img alt="hero" src={HeroIcon} />
      </div>
    </Page>
  );
};

export default WaitingApplication;
